import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/content");
      setContent(data && Object.keys(data).length ? data : {});
    } catch {
      setContent({});
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return <ContentContext.Provider value={{ content: content || {}, refresh }}>{children}</ContentContext.Provider>;
}

export function useContent() {
  const ctx = useContext(ContentContext);
  if (!ctx) throw new Error("useContent within ContentProvider");
  return ctx;
}
